import * as React from 'react';

function withTitan(func, options) {
  const {
    memo = false,
    name = ''
  } = options || {};
  // explicit typed 'any' to accept any 'HTMLElement'.
  let el = func;
  el.displayName = el.displayName || name;
  if (func.length === 2) {
    el = React.forwardRef(el);
  }
  if (memo) {
    el = React.memo(el);
  }
  return el;
}

export { withTitan };
//# sourceMappingURL=withTitan.js.map
